import { FormGroup, FormControl, ValidatorFn } from '@angular/forms';

/**
 * Validate matching passwords.
 */
export function validateMatch(matchControlName: string): ValidatorFn {
  return (formControl: FormControl) => {
    const formGroup = (formControl as any)._parent as FormGroup;
    if (formGroup && formControl.value !== formGroup.get(matchControlName).value) {
      console.log('password do not match');
      return { noMatch: true };
    }
    return null;
  };
}

/**
 * Validate a checkbox.
 */
export function validateCheckbox(formControl: FormControl): any {
  return !formControl.value ? { required: true } : null;
}
